import { EprUinListResp } from 'types/api/response/epr-uin-list-resp'

import { api } from './api'

export const getEprUinList = () => api.get<EprUinListResp>('/business_accounts/epr_uins')
